/**
 * Get lesson status relative to current Lisbon time.
 * Returns: "in_progress" | "upcoming_today" | "upcoming" | "past"
 */
export const getLessonStatus = (lesson) => {
  if (!lesson.date || !lesson.start_time || !lesson.end_time) return "upcoming";

  // Get current Lisbon time
  const now = new Date();
  const lisbonNow = new Date(now.toLocaleString("en-US", { timeZone: "Europe/Lisbon" }));
  
  const todayStr = lisbonNow.toISOString().slice(0, 10);
  const currentHHMM = lisbonNow.getHours() * 60 + lisbonNow.getMinutes();
  
  if (lesson.date < todayStr) return "past";
  if (lesson.date > todayStr) return "upcoming";
  
  // Lesson is today - check times
  const [startH, startM] = lesson.start_time.split(":").map(Number);
  const [endH, endM] = lesson.end_time.split(":").map(Number);
  const startMinutes = startH * 60 + startM;
  const endMinutes = endH * 60 + endM;
  
  if (currentHHMM >= startMinutes && currentHHMM < endMinutes) return "in_progress";
  if (currentHHMM < startMinutes) return "upcoming_today";
  return "past";
};

/**
 * Get a display label for lesson status in Portuguese.
 * isFirst: whether this is the first upcoming lesson (shown as "Próxima")
 */
export const getLessonStatusLabel = (lesson, isFirst = false) => {
  const status = getLessonStatus(lesson);
  switch (status) {
    case "in_progress": return "A Decorrer";
    case "upcoming_today": return isFirst ? "Próxima" : "Hoje";
    case "upcoming": return isFirst ? "Próxima" : "Agendada";
    case "past": return "Terminada";
    default: return "";
  }
};

/**
 * Get badge color classes for lesson status
 */
export const getLessonStatusColor = (status) => {
  switch (status) {
    case "in_progress": return "bg-[#10B981] text-white";
    case "upcoming_today": return "bg-[#F59E0B] text-white";
    case "upcoming": return "bg-[#0F4C81] text-white";
    case "past": return "bg-[#94A3B8] text-white";
    default: return "bg-[#6697a4] text-white";
  }
};
